module.exports = __webpack_public_path__ + "img/0.d3328522.jpg";